<style scoped lang="scss">
.openboxlist {
  position: relative;
  width: 100%;
  padding: 0;
  display: flex;
  margin-top: 20px;
  .left {
    font-size: 16px;
    font-family: PingFang SC-常规体, PingFang SC;
    font-weight: normal;
    color: #1a1a1a;
    line-height: 24px;
  }
}
.box {
  margin-left: 40px;
  padding-bottom: 20px;
  flex: 1;
  .ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    .li {
      position: relative;
      margin-right: 10px;
      margin-bottom: 10px;
      // &:first-child {
      //   margin-left: 0;
      // }
      &:nth-of-type(3n) {
        margin-right: 0;
      }
      .img {
        position: relative;
        width: 78px;
        height: 109px;
        background: #f2f2f2;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #f2f2f2;
        img {
          border-radius: 4px;
          width: 100%;
          height: 100%;
        }
      }
      .name {
        width: 78px;
        margin: 0 auto;
        margin-top: 5px;
        font-size: 12px;
        font-family: PingFang SC-常规体, PingFang SC;
        font-weight: normal;
        color: #7f7f7f;
        line-height: 18px;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        text-align: center;
      }
    }
  }
}
.bt-box{
  text-align: center;
}
.bt {
  margin: 0 auto;
}
</style>

<template>
  <div class="openboxlist">
    <div class="left">拆盒结果</div>
    <div class="box">
      <div class="ul">
        <div class="li" v-for="(item, idx) in list" :key="idx">
          <div class="img">
            <img :src="item.card_icon" alt="" />
          </div>
          <div class="name">{{ item.card_name }}</div>
        </div>
      </div>
      <div class="bt-box" v-if="bt&&card_info.card_total">
        <!-- <div class="bt" @click="getlist">
          查看全部({{ card_info.card_total }})
        </div> -->
        <el-button class="bt" @click="getlist" type="" size="small" text bg>查看全部({{ card_info.card_total }})</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { orderCards } from "@api";
export default {
  name: "openboxlist",
  data() {
    return {
      mes: "",
      bt:true,
      list: [],
    };
  },
  components: {},
  watch: {},
  computed: {},
  props: ["orderId", "orderInfo", "card_info"],
  mounted() {
    this.list = this.card_info.card_list;
  },
  methods: {
    toProject() {
      location.href = `/luckycards/container`;
    },
    close() {
      this.$emit("close");
    },
    getlist() {

      const order = {
        url: "/apis/mdorder/cards",
        method: "get",
        props: {
          order_id: this.orderId,
          page: 1,
          page_size: 999,
        },
      };
      orderCards(order.props).then((e) => {
        if (e.status == 0) {
          this.list = e.data.list;
          this.bt = false
        }
      });
    },
    dialogBack() {
      this.$emit("dialogBack");
    },
    op(type) {
      this.$emit("toOp", type);
    },
  },
};
</script>
